/** localStorage key + helpers for field UI text size (normal | large). */

export type FieldTextSize = 'normal' | 'large'

export const FIELD_TEXT_SIZE_KEY = 'rbcfs.field_text_size'

export function isFieldTextSize(value: unknown): value is FieldTextSize {
  return value === 'normal' || value === 'large'
}

export function readFieldTextSize(): FieldTextSize {
  try {
    const raw = localStorage.getItem(FIELD_TEXT_SIZE_KEY)
    return isFieldTextSize(raw) ? raw : 'normal'
  } catch {
    return 'normal'
  }
}

export function writeFieldTextSize(size: FieldTextSize): void {
  try {
    localStorage.setItem(FIELD_TEXT_SIZE_KEY, size)
  } catch {
    // ignore quota / private mode
  }
}

/** Toggle `field-text-large` on `<html>` for mobile / PWA shells. */
export function applyFieldTextSize(size: FieldTextSize = readFieldTextSize()): void {
  if (typeof document === 'undefined') return
  document.documentElement.classList.toggle('field-text-large', size === 'large')
}
